import { useState } from "react";
import ArrowBottomIcon from "../../../assets/svgs/common/arrow-bottom.svg";
import { AccountType } from "../../../constants/account-types.constants";
import { useUserStore } from "../../../store/user.store";
import HamburgerIcon from "../../assets/svgs/hamburger.svg";
import Logo from "../../assets/svgs/logo.svg";
import Button from "../core/button.core";
import { Sheet, SheetContent, SheetTrigger } from "../core/sheet.core";
import LogoutIcon from "../../../assets/svgs/common/logout.svg";
import { NavLink, useNavigate, useParams, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import ProfileIcon from "../../assets/svgs/profile.svg";
import CollabsIcon from "../../assets/svgs/collabs.svg";

export default function Nav() {
  const { user, logout, brands } = useUserStore();
  const [sheetOpen, setSheetOpen] = useState(false);
  const [dropMenuOpen, setDropMenuOpen] = useState(false);
  const { collabId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  function HandleReturnMenu() {
    const items = [];

    items.push(
      ...[
        {
          name: "Campaigns",
          link: "/brands/campaigns/live",
          icon: CollabsIcon,
          activePattern: "/brands/campaigns",
        },
        {
          name: "Profile",
          link: "/brands/account/profile",
          icon: ProfileIcon,
          activePattern: "/brands/account/profile",
        },
      ]
    );
    return items;
  }

  const isMenuActive = (activePattern: string) => {
    return location.pathname.includes(activePattern);
  };

  return (
    <div className="flex justify-between items-center p-5 w-full">
      {window.location.pathname.includes(`/brands/collabs/${collabId}`) ? (
        <div className="flex items-center gap-3 w-full font-cabinetgrotesk text-sm md:text-xl tracking-tight">
          <Button
            onClick={() => {
              navigate("/brands/collabs");
            }}
            className="p-1"
            variant="secondary"
          >
            <ChevronLeft />
          </Button>
          <div className="pt-1 text-sm">Back to collabs</div>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <Logo />
        </div>
      )}
      <div className="flex justify-center items-center">
        <Sheet
          defaultOpen={false}
          onOpenChange={(open) => setSheetOpen(open)}
          open={sheetOpen}
        >
          <SheetTrigger>
            <Button className="px-4 w-full" variant="secondary">
              <HamburgerIcon />
            </Button>
          </SheetTrigger>
          <SheetContent className="flex flex-col items-center bg-white px-0 w-full max-w-xs h-full text-black">
            <div className="flex flex-col justify-between items-left w-full h-full">
              <div className="flex flex-col gap-4 px-2 pt-12 w-full">
                {HandleReturnMenu()?.map((menu, idx) => {
                  const isActive = isMenuActive(menu.activePattern);
                  return (
                    <NavLink
                      // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                      key={idx}
                      to={menu.link}
                      className={`flex items-center gap-2 font-semibold ${
                        isActive ? "text-black" : "text-secondary"
                      }`}
                    >
                      <div className="w-full">
                        <Button
                          variant={isActive ? "secondary" : "outline"}
                          onClick={() => setSheetOpen(false)}
                          className={`flex items-center pl-5 pr-0 py-3 w-full text-sm ${
                            isActive ? "text-black" : "text-secondary border-0"
                          }`}
                        >
                          <div className="flex items-center gap-2 w-full">
                            <menu.icon /> {menu.name}
                          </div>
                        </Button>
                      </div>
                    </NavLink>
                  );
                })}
              </div>
              <div className="flex flex-col w-full">
                <div className="flex items-center gap-2 pt-5 pb-0 pl-4 border-t w-full">
                  <img
                    width={40}
                    height={40}
                    src={brands?.[0]?.logo?.url || "/static/profile.png"}
                    className="rounded-full w-10 h-10 object-cover"
                    alt=""
                  />
                  <div className="flex flex-col">
                    <p className="font-semibold text-secondary text-xs">
                      Logged in as
                    </p>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <p
                      onClick={() => setDropMenuOpen(!dropMenuOpen)}
                      className="flex font-figtree font-semibold text-lg cursor-pointer"
                    >
                      {user?.accountType === AccountType.EPHEMERAL &&
                        user?.name}
                      {user?.accountType === AccountType.ADMIN && user?.name}
                      {user?.accountType === AccountType.BRAND && user?.name}
                      <span
                        className={
                          dropMenuOpen
                            ? "rotate-180 transition-all"
                            : "rotate-0 transition-all"
                        }
                      >
                        <ArrowBottomIcon />
                      </span>
                    </p>
                  </div>
                </div>
                {dropMenuOpen ? (
                  <div className="flex flex-col pt-5 pl-4 w-fit font-semibold">
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <Button
                      onClick={logout}
                      variant="secondary"
                      className="flex gap-2 px-5 py-2 text-rejectbuttontext cursor-pointer"
                    >
                      <LogoutIcon />
                      Logout
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
}
